<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import Swal from "sweetalert2";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: 'TiketPage',
  components: {FooterPage, NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)
    let tickets = ref([])

    function load_ticket() {

      loading.value = true
      FreeWorld.Heisenberg({action: 'show_ticket',}, 'tickets', true).then((result) => {

        loading.value = false
        var res = result.data
        tickets.value = res

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_ticket()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_ticket()
            }
          })
        }
      })
    }

    load_ticket()

    return {
      loading,
      tickets,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          تیکت های من
        </p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="tickets.length != 0 " class="p-body mt-2 animate__animated animate__fadeIn">
      <div v-for="item in tickets" :key="item.id" class="p-3 rounded-4 bg-white mb-2">
        <div class="d-flex justify-content-between align-items-center position-relative">
          <p class="font-5 px-4 m-0">
                    <span>
                        {{ item.time }}
                    </span>
            &nbsp;
            <span>
                        {{ item.date }}
                    </span>
          </p>
          <p class="font-4 font-bold m-0">
            {{ item.subject }}
          </p>
        </div>
        <hr>
        <div dir="rtl" class="w-100">
          <p class="text_chat_user m-0 w-75 font-5">
            {{ item.text }}
          </p>
        </div>
      </div>
    </div>

    <div v-else style="height: 100vh" class="d-flex justify-content-center align-items-center">
      <p>
        !شما هنوز تیکتی ارسال نکرده اید
      </p>
    </div>
  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>
    <div class="rounded-4 bg-white font-bold font-color p-3 mb-4 w-75 ma-auto">تیکت های من</div>

    <div style="height: 75vh" class="bg-white overflow-y-scroll p-4 rounded-4 w-75 m-auto">
      <div v-if="tickets.length != 0 " class="p-body mt-2 animate__animated animate__fadeIn">
        <div v-for="item in tickets" :key="item.id" class="p-3 rounded-4 shadow-costom bg-white mb-2">
          <div class="d-flex justify-content-between align-items-center position-relative">
            <p class="font-3 font-bold m-0">{{ item.subject }}</p>
            <p class="font-4 px-4 m-0">
                    <span>
                        {{ item.time }}
                    </span>
              &nbsp;
              <span>
                        {{ item.date }}
                    </span>
            </p>
          </div>
          <hr>
          <div dir="rtl" class="w-100">
            <p class="text_chat_user m-0 w-75 font-4">
              {{ item.text }}
            </p>
          </div>
        </div>
      </div>

      <div v-else class="d-flex justify-content-center h-100 align-items-center">
        <p>
          !شما هنوز تیکتی ارسال نکرده اید
        </p>
      </div>
    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.text_chat_user {
  height: 40px;
  white-space: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}

</style>